import React from 'react';
import HeroImage from '../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../assets/images/services/banking-license/page-banner.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Button from "../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Financial License – Anjouan (Comoros)',
        link: '/financial-license-anjouan',
    },
]

function GibraltarBankingFinTechLicense () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Gibraltar Banking & FinTech License
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                A Trusted Gateway for Banks, PSPs, EMIs & Blockchain Finance
                            </h3>
                            <p className='page-paragraph'>
                                <b>Gibraltar</b> is an <b>international financial center</b> that combines <b>regulatory strength</b> with <b>innovation</b>. It is home to <b>licensed banks, PSPs, EMIs, and blockchain fintech firms</b>, all operating under the supervision of the <b>GFSC</b>.
                                <br/>
                                The jurisdiction’s <b>UK market access</b>, <b>low tax regime</b>, and <b>DLT-friendly policies</b> make it a prime choice for <b>digital banks, fintech startups, and blockchain-based payment solutions</b>.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Banking",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Payment Service Providers (PSPs)",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "EMIs",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Blockchain Finance",
                                        icon: GiCheckMark,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Gibraltar Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Gibraltar for Banking & FinTech?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Reputation",
                                    paragraph: "Credibility with banks, regulators, and investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong Regulator",
                                    paragraph: "GFSC ensures solvency & compliance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "DLT Pioneer",
                                    paragraph: "First in Europe to regulate blockchain finance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "UK Market Access",
                                    paragraph: "Post-Brexit access maintained in financial sectors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Benefits",
                                    paragraph: "10% corporate tax, no capital gains, no VAT",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Financial Licenses in Gibraltar</h3>
                        <p className='page-subtitle'>1. Private Limited Company (Pte Ltd)</p>
                        <PageList
                            items={[
                                { paragraph: "Most common structure.", icon: GoDotFill },
                                { paragraph: "Limited liability for shareholders.", icon: GoDotFill },
                                { paragraph: "Ideal for startups, SMEs, trading, fintech, and holding companies.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Public Company (Limited by Shares or Guarantee)</p>
                        <PageList
                            items={[
                                { paragraph: "For large enterprises and organizations.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Branch or Subsidiary</p>
                        <PageList
                            items={[
                                { paragraph: "For foreign companies expanding into Singapore.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Capital & Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Banking License",
                                    paragraph: "EUR 5m+ minimum capital",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "PSP License",
                                    paragraph: "EUR 125k+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EMI License",
                                    paragraph: "EUR 350k+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity",
                                    paragraph: "Gibraltar-incorporated company",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Resident Presence",
                                    paragraph: "2 local directors + compliance officer",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Office",
                                    paragraph: "Physical office required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Compliance",
                                    paragraph: "AML/KYC, IT security, and risk frameworks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Audit",
                                    paragraph: "Annual financial and regulatory audits",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Gibraltar Banking & FinTech License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Prestige",
                                    paragraph: "Tier-1 jurisdiction with global reputation",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Clear Regulatory Framework",
                                    paragraph: "Especially for blockchain finance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "PSPs and EMIs can integrate with global banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "DLT Integration",
                                    paragraph: "Ideal for crypto-fiat hybrid models",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Business Taxation",
                                    paragraph: "Only 10% corporate tax",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define license type (bank, PSP, EMI)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity Incorporation",
                                    paragraph: "Establish company in Gibraltar",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Preparation",
                                    paragraph: "Compliance docs, AML manuals, financial plan",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "GFSC Review",
                                    paragraph: "Due diligence on directors, shareholders, and governance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Typically 6–12 months",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "6–12 months",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From GBP 75,000+ depending on license",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "EUR 125k–5m depending on scope",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "GFSC fees, audits, compliance",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking for a Tier-1 banking or fintech license?"
                        description=
                            "<b>Gibraltar</b> offers <b>banking, PSP, EMI, and blockchain licensing</b> under the <b>GFSC</b>, trusted by <b>banks, investors, and regulators worldwide</b>."
                        buttonText="Book a Gibraltar Banking & FinTech Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default GibraltarBankingFinTechLicense;

const faqData = [
    {
        question: "Is there a capital requirement for an Anjouan financial license?",
        content: [
            { type: "answer", text: "No — unlike Mauritius or Cyprus, AOFA does not require minimum capital." },
        ],
    },
    {
        question: "How long does it take to get licensed?",
        content: [
            { type: "answer", text: "Typically 4–8 weeks, faster than most offshore centers." },
        ],
    },
    {
        question: "Can I operate globally with this license?",
        content: [
            { type: "answer", text: "Yes — Anjouan licenses are designed for international operations, not domestic business." },
        ],
    },
    {
        question: "Can I combine services (e.g., forex + payments)?",
        content: [
            { type: "answer", text: "Yes — AOFA offers modular licensing so you can combine multiple services." },
        ],
    },
    {
        question: "Is it crypto-friendly?",
        content: [
            { type: "answer", text: "Yes — crypto payments, exchanges, and hybrid forex + crypto models are supported." },
        ],
    },
];



const testimonialsData = [
    {
        quote:
            "We secured a Gibraltar EMI license to launch our e-wallet. Offshore Advisory managed the GFSC application.",
        author: "David H.",
        role: "FinTech CEO",
    },
    {
        quote:
            "Our blockchain PSP needed Tier-1 credibility. Gibraltar licensing gave us investor confidence.",
        author: "Alina R.",
        role: "Payment Provider",
    },
];